module.exports = __webpack_public_path__ + "img/rain.fe104dc1.gif";